<template>
  <div class="animated fadeIn tickets">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <div>
            <div style="overflow-x: auto">
              <b-table
                id="ticket-authorizations-table"
                :busy.sync="isBusy"
                show-empty
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :hover="true"
                :striped="true"
                stacked="md"
                v-model="copy"
                :items="provider"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                @row-clicked="rowClicked"
                tbody-tr-class="tr-pointer"
                v-columns-resizable="{ afterResize: columnsWidthChanged }"
              >
                <template v-slot:empty="scope">
                  <div class="text-center">{{ $t(scope.emptyText) }}</div>
                </template>

                <template slot="HEAD_view">&nbsp;</template>

                <template v-slot:head(eid)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(eticket_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(etenant_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(eshop_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(eterminal_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(queue_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(review_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(ereview_user_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(handled)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(handled_status)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(settle_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(esettle_user_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(reason)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(type)="data">{{
                  $t(data.label)
                }}</template>

                <template v-slot:cell(view)="">
                  <i
                    class="la la-eye p-s"
                    style="font-size: 1.5rem; color: #ccc"
                  />
                </template>

                <template v-slot:cell(queue_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>

                <template v-slot:cell(review_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>

                <template v-slot:cell(handled_status)="data">{{
                  $t(handledStatus(data.value))
                }}</template>

                <template v-slot:cell(settle_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>

                <template v-slot:cell(eticket_id)="data">
                  <span v-if="data.value">
                    <router-link :to="`/tickets/${data.value}`">{{
                      data.item.ticket_serial
                        ? data.item.ticket_serial
                        : data.value
                    }}</router-link>
                  </span>
                </template>

                <template v-slot:cell(eterminal_id)="data">
                  <span v-if="data.value">
                    <router-link
                      :to="`/shops/${
                        data.item.eshop_id && data.item.eshop_id.to
                          ? data.item.eshop_id.to
                          : data.item.eshop_id
                      }`"
                      >{{ data.value }}</router-link
                    >
                  </span>
                </template>

                <template v-slot:cell(etenant_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/tenants/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(eshop_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/shops/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(ereview_user_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/users/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(type)="data">
                  <span v-if="data.value == 1">{{ $t("authorization") }}</span>
                  <span v-else>{{ $t("reprint") }}</span>
                </template>

                <template v-slot:cell(esettle_user_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/users/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="container-fluid">
              <div class="row">
                <div style="white-space: nowrap" class="my-2">
                  <PaginationSelect
                    v-model="perPage"
                    :options="paginationOpts"
                    variant="light"
                    size="sm"
                  />
                  <span>
                    &nbsp;
                    <i18n
                      path="Showing {start}-{end} of {total} rows"
                      tag="span"
                    >
                      <span slot="start">{{
                        (currentPage - 1) * perPage + 1
                      }}</span>
                      <span slot="end">{{ currentPage * perPage }}</span>
                      <span slot="total">{{ totalRows }}</span>
                    </i18n>
                  </span>
                  <b-button
                    size="sm"
                    @click.stop="
                      $root.$emit(
                        'bv::refresh::table',
                        'ticket-authorizations-table'
                      )
                    "
                    class="ml-2 refresh"
                    variant="light"
                    :title="$t('Refresh')"
                  >
                    <i class="icon-refresh"></i>
                  </b-button>
                </div>
                <nav class="ml-auto mt-2">
                  <b-pagination
                    size="md"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="bv-modal-review-ticket"
      size="lg"
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <template slot="modal-title">
        <div style="white-space: nowrap">
          <span v-if="selectedType == 1">{{ $t("Review Ticket") }}</span>
          <span v-if="selectedType == 2">{{
            $t("Review Ticket Reprint")
          }}</span>
          <span v-if="expiresIn" style="font-size: 0.9rem">
            ({{ $t("expires in") }}
            <strong>
              <Timer
                :start="expiresIn"
                @action="timerOff"
                style="display: inline-block"
              /> </strong
            >)
          </span>
        </div>
      </template>
      <div class="d-block" style="position: relative">
        <div v-if="!selectedTicket" class="text-center">
          <b-spinner variant="dark" label="Spinning"></b-spinner>
        </div>
        <div v-if="selectedTicket" class="border rounded p-2">
          <table class="table table-borderless table-striped table-sm m-0">
            <tbody>
              <tr>
                <th scope="row" class="text-right">{{ $t("Lottery") }}</th>
                <td>
                  {{ selectedTicket.event_code }}.
                  {{ selectedTicket.event_name }} [{{
                    mom_unix(selectedTicket.event_time).format(
                      "DD-MM-YY HH:mm:ss"
                    )
                  }}]
                </td>
              </tr>
              <tr>
                <th scope="row" class="text-right">{{ $t("Serial") }}</th>
                <td>{{ selectedTicket.ticket_id }}</td>
              </tr>
              <tr>
                <th scope="row" class="text-right">{{ $t("Registration") }}</th>
                <td>
                  {{
                    mom_unix(selectedTicket.registration_time).format(
                      "DD-MM-YY HH:mm:ss"
                    )
                  }}
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  class="text-right"
                  style="vertical-align: middle"
                >
                  {{ $t("Selected Numbers") }}
                </th>
                <td>
                  <div class="d-flex flex-row flex-wrap">
                    <div
                      v-for="(item, index) in selectedTicket.selected_numbers"
                      :key="index"
                    >
                      <div
                        class="m-2 rounded-circle bg-info text-white text-center"
                        style="width: 30px; height: 30px; line-height: 30px"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  class="text-right"
                  style="vertical-align: middle"
                >
                  {{ $t("Ticket Systems") }}
                </th>
                <td>
                  <div class="d-flex flex-row flex-wrap">
                    <div
                      v-for="(item, index) in selectedTicket.ticket_systems"
                      :key="index"
                    >
                      <div
                        class="m-2 px-2 py-1 rounded bg-success text-white text-center"
                      >
                        {{ item }}/{{ selectedTicket.selected_numbers.length }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  class="text-right"
                  style="vertical-align: middle"
                >
                  {{ $t("Info") }}
                </th>
                <td>
                  <table
                    class="table table-borderless table-sm mb-0"
                    style="width: auto"
                  >
                    <tr style="background-color: transparent">
                      <td class="text-right">{{ $t("Stake") }}:</td>
                      <th>{{ roundThousands(selectedTicket.stake) }}</th>
                      <td class="text-right">{{ $t("Tax") }}:</td>
                      <th>{{ roundThousands(selectedTicket.tax) }}</th>
                    </tr>
                    <tr style="background-color: transparent">
                      <td class="text-right">{{ $t("Min Winning") }}:</td>
                      <th>{{ roundThousands(selectedTicket.min_winning) }}</th>
                      <td class="text-right">{{ $t("Max Winning") }}:</td>
                      <th>{{ roundThousands(selectedTicket.max_winning) }}</th>
                    </tr>
                    <tr style="background-color: transparent">
                      <td class="text-right">{{ $t("Number Of Lines") }}:</td>
                      <th>{{ selectedTicket.number_of_lines }}</th>
                      <td colspan="2"></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <th scope="row" class="text-right">{{ $t("Total Amount") }}</th>
                <td>
                  {{ roundThousands(selectedTicket.total_amount) }}
                  {{ $t("lei") }}
                </td>
              </tr>
              <tr
                v-if="selectedTicket && selectedTicket.ethird_party_player_id"
              >
                <td colspan="2" class="local-pt">
                  <FloatingLabel
                    :value="
                      valueOfId(
                        selectedTicket.ethird_party_player_id,
                        'thirdPartyPlayers'
                      )
                    "
                    label="Third Party Player"
                    :to="`/third-party-players/${selectedTicket.ethird_party_player_id}`"
                    type="link"
                    size="sm"
                    :readonly="true"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex flex-column justify-content-around">
          <div v-if="selectedReason" class="mt-4">
            <FloatingLabel
              :value="selectedReason"
              label="Reason for manual authorization"
              type="plain"
              size="sm"
            />
          </div>
          <div v-if="!selectedHandled" class="my-2">
            <FloatingLabel
              v-model="cancelReason"
              label="Reason for rejecting"
              type="textarea"
              size="sm"
            />
          </div>
          <div class="text-right mt-2">
            <b-button type="button" variant="secondary" @click="endReview">{{
              $t("Cancel")
            }}</b-button>
            <b-button
              v-if="!selectedHandled"
              type="button"
              variant="danger"
              class="ml-3"
              @click="endReviewWithAuthorization(false)"
              >{{ $t("Reject") }}</b-button
            >
            <b-button
              v-if="!selectedHandled"
              type="button"
              variant="success"
              class="ml-3"
              @click="endReviewWithAuthorization(true)"
              >{{ $t("Authorize") }}</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { evbus } from "@/shared/ws";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import BulkActionSelect from "@/components/BulkActionSelect";
import { successConf, errorConf } from "@/shared/notifications";
import FloatingLabel from "@/components/FloatingLabel";
import Timer from "@/components/Timer";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    BulkActionSelect,
    FloatingLabel,
    Timer,
  },
  name: "TicketAuthorizations",
  mixins: [tableMixin],
  data: function () {
    return {
      tableName: "ticketAuthorizations",

      filterOptions: [
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          options: [],
          selected: [],
        },
        {
          field: "shop_id",
          multiple: true,
          placeholder: "Shop",
          trackBy: "eid",
          translate: false,
          label: "name",
          store: "shops",
          options: [],
          selected: [],
        },
        {
          field: "handled",
          placeholder: "Handled",
          options: [
            { name: "Yes", value: true },
            { name: "No", value: false },
          ],
          selected: [],
        },
        {
          field: "queue_time",
          type: "date",
          stateIgnore: true,
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
        },
      ],

      isBusy: false,
      sortBy: "queue_time",
      sortDesc: true,
      fields: [
        {
          key: "view",
          ignore: true,
          dpIgnore: true,
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          ignore: true,
          class: "d-none",
        },
        {
          key: "eticket_id",
          label: "Ticket",
          sortable: true,
          class: "",
          ignore: true,
        },
        {
          key: "etenant_id",
          label: "Tenant",
          sortable: true,
          class: "",
          ignore: true,
        },
        {
          key: "eshop_id",
          label: "Shop",
          sortable: true,
          class: "",
          ignore: true,
        },
        {
          key: "eterminal_id",
          label: "Terminal",
          sortable: true,
          class: "",
          ignore: true,
        },
        { key: "queue_time", sortable: true, class: "", ignore: true },
        { key: "review_time", sortable: true, class: "", ignore: true },
        {
          key: "ereview_user_id",
          label: "Reviewed by",
          sortable: true,
          class: "",
          ignore: true,
        },
        { key: "handled", sortable: true, class: "", ignore: true },
        { key: "type", sortable: true, class: "", ignore: true },
        {
          key: "handled_status",
          label: "Status",
          sortable: true,
          class: "",
          ignore: true,
        },
        {
          key: "reason",
          label: "Reason",
          sortable: true,
          class: "",
          ignore: true,
        },
        { key: "settle_time", sortable: true, class: "", ignore: true },
        {
          key: "esettle_user_id",
          label: "Settled by",
          sortable: true,
          class: "",
          ignore: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      copy: null,

      selectedTicket: null,
      selectedAuthorization: null,
      selectedHandled: null,
      selectedReason: null,
      cancelReason: null,
      selectedType: null,
      expiresIn: 0,
    };
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    },
    $route(to) {
      if (to && to.params && to.params.id) {
        const authz_id = to.params.id;
        const notificationByID = this.$store.getters["ws/notificationByID"];
        const data = notificationByID(authz_id);
        if (data) {
          const item = {
            eid: authz_id,
            handled: false,
            reason: data.reason,
            eticket_id: data.ticket_id,
            type: data.type,
          };
          this.rowClicked(item);
        }
      }
    },
  },
  mounted() {
    const authz_id = this.$route.params.id ? this.$route.params.id : "";

    if (authz_id) {
      const notificationByID = this.$store.getters["ws/notificationByID"];
      const data = notificationByID(authz_id);
      if (data) {
        const item = {
          eid: authz_id,
          handled: false,
          reason: data.reason,
          eticket_id: data.ticket_id,
          type: data.type,
        };
        this.rowClicked(item);
      }
    }

    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "bv-modal-review-ticket") {
        // do nothing
      }
    });

    this.websocketAuthorizationCB = this.websocketAuthorization.bind(this);
    evbus.on(
      "ws.notification.authorization_refresh",
      this.websocketAuthorizationCB
    );
  },
  destroyed() {
    this.$root.$off("bv::modal::show");
    evbus.remove(
      "ws.notification.authorization_refresh",
      this.websocketAuthorizationCB
    );
  },
  methods: {
    timerOff() {
      this.expiresIn = 0;
      this.selectedHandled = true;
    },
    handledStatus(val) {
      let status = "pending";

      switch (val) {
        case 1:
          status = "authorized";
          break;
        case 2:
          status = "rejected";
          break;
        case 3:
          status = "ask";
          break;
        case 4:
          status = "auto rejected";
          break;
      }

      return status;
    },
    websocketAuthorization() {
      this.refresh();
    },
    refresh() {
      this.$root.$emit("bv::refresh::table", "ticket-authorizations-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "eticket_id") sortBy = "ticket_id";
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        if (sortBy == "eshop_id") sortBy = "shop_id";
        if (sortBy == "eterminal_id") sortBy = "terminal_id";
        if (sortBy == "ereview_user_id") sortBy = "review_user_id";
        if (sortBy == "esettle_user_id") sortBy = "settle_user_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.type != "date") {
          if (item.selected.length) {
            exactFields.push(item.field);
            if (item.trackBy) {
              const tmp = [];
              item.selected.forEach((el) => {
                tmp.push(el[item.trackBy]);
              });
              exactValues.push(tmp);
            } else {
              exactValues.push(item.selected);
            }
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      const tenantByID = this.$store.getters["cache/tenantByID"];
      const userByID = this.$store.getters["cache/userByID"];
      const shopByID = this.$store.getters["cache/shopByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "tenants").catch((e) => e),
        this.$store.dispatch("cache/fetch", "users").catch((e) => e),
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
      ]).finally(() => {
        this.$store
          .dispatch("lotteryTicketAuthorization/fetch", paginationData)
          .then((resp) => {
            this.totalRows = resp.data.total;

            resp.data.rows.forEach((item, index) => {
              if (item.etenant_id) {
                const data = tenantByID(item.etenant_id);
                if (data) {
                  item.etenant_id = {
                    to: item.etenant_id,
                    name: data.brand_name,
                  };
                } else {
                  item.etenant_id = {
                    to: null,
                    name: item.etenant_id,
                  };
                }
              }

              if (item.eshop_id) {
                const data = shopByID(item.eshop_id);
                if (data) {
                  item.eshop_id = {
                    to: item.eshop_id,
                    name: data.name,
                  };
                } else {
                  item.eshop_id = {
                    to: null,
                    name: item.eshop_id,
                  };
                }
              }

              if (item.ereview_user_id) {
                if (item.ereview_user_id == "LOIQ6p7TaKDBIpfb-Pvm_A") {
                  item.ereview_user_id = {
                    to: null,
                    name: "backoffice",
                  };
                } else {
                  const data = userByID(item.ereview_user_id);
                  if (data) {
                    item.ereview_user_id = {
                      to: item.ereview_user_id,
                      name: data.username,
                    };
                  } else {
                    item.ereview_user_id = {
                      to: null,
                      name: item.ereview_user_id,
                    };
                  }
                }
              }

              if (item.esettle_user_id) {
                const data = userByID(item.esettle_user_id);
                if (data) {
                  item.esettle_user_id = {
                    to: item.esettle_user_id,
                    name: data.username,
                  };
                } else {
                  item.esettle_user_id = {
                    to: null,
                    name: item.esettle_user_id,
                  };
                }
              }
              resp.data.rows[index]["_cellVariants"] = {};
              if (item.handled) {
                resp.data.rows[index]["_cellVariants"].handled = "success";
              } else {
                resp.data.rows[index]["_cellVariants"].handled = "danger";
              }
              if (item.handled_status == 1) {
                resp.data.rows[index]["_cellVariants"].handled_status =
                  "success";
              } else if (item.handled_status == 2) {
                resp.data.rows[index]["_cellVariants"].handled_status =
                  "danger";
              } else {
                resp.data.rows[index]["_cellVariants"].handled_status = "info";
              }
            });

            callback(resp.data.rows);
          })
          .catch((err) => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    async rowClicked(item) {
      this.selectedAuthorization = item.eid;
      this.selectedHandled = item.handled;
      this.selectedReason = item.reason;
      this.selectedType = item.type;
      this.expiresIn = 0;
      const ticketid = item.eticket_id;
      this.showReview();

      let ticket = null;

      try {
        ticket = await this.$store.dispatch("ticket/read", ticketid);
      } catch (err) {
        return this.showErrorNotification(err);
      }

      try {
        await this.$store.dispatch("cacheOnDemand/fetch", {
          key: "thirdPartyPlayers",
          ids: [ticket.data.ethird_party_player_id],
        });
      } catch (err) {
        /*noop*/
      }

      let authorization = null;
      try {
        authorization = await this.$store.dispatch(
          "lotteryTicketAuthorization/start",
          item.eid
        );
        if (authorization && authorization.success) {
          if (!this.selectedHandled) {
            this.expiresIn = authorization.data.remaining_time;
          }
        }
      } catch (err) {
        this.hideReview();
        this.selectedAuthorization = null;
        this.selectedHandled = null;
        this.selectedReason = null;
        this.selectedTicket = null;
        this.selectedType = null;
        return this.showErrorNotification(err);
      }
      ticket.data.eid = ticketid;
      this.selectedTicket = ticket.data;
    },
    showReview() {
      this.$bvModal.show("bv-modal-review-ticket");
    },
    hideReview() {
      this.$bvModal.hide("bv-modal-review-ticket");
    },
    async endReviewWithAuthorization(status) {
      let authorization = null;

      let stat = 2;
      if (status) {
        stat = 1;
      }

      try {
        authorization = await this.$store.dispatch(
          "lotteryTicketAuthorization/end",
          {
            id: this.selectedAuthorization,
            ticket_id: this.selectedTicket.eid,
            authorized: stat,
            reason: this.cancelReason,
          }
        );
      } catch (err) {
        this.showErrorNotification(err);
      }

      //this.$store.dispatch("ws/removeNotification", this.selectedAuthorization);

      this.selectedAuthorization = null;
      this.selectedHandled = null;
      this.selectedReason = null;
      this.selectedTicket = null;
      this.cancelReason = null;
      this.selectedType = null;
      this.hideReview();
      this.refresh();
    },
    async endReview() {
      let authorization = null;
      if (!this.selectedHandled) {
        try {
          authorization = await this.$store.dispatch(
            "lotteryTicketAuthorization/end",
            {
              id: this.selectedAuthorization,
              ticket_id: this.selectedTicket.eid,
              cancel: true,
            }
          );
        } catch (err) {
          this.showErrorNotification(err);
        }
      }

      //this.$store.dispatch("ws/removeNotification", this.selectedAuthorization);
      this.hideReview();
      this.selectedAuthorization = null;
      this.selectedHandled = null;
      this.selectedReason = null;
      this.selectedTicket = null;
      this.selectedType = null;
      this.cancelReason = null;
      this.expiresIn = 0;
    },
    redirect() {},
    mom_unix(val) {
      if (!val)
        return {
          format() {
            return "";
          },
        };
      return moment.unix(val / 1e9);
    },
    roundThousands(value) {
      if (typeof value == "string") return value;
      if (!value) return "0.00";

      const decimals = 2;
      const tmp = value / 10000;

      return Number(Math.round(tmp + "e" + decimals) + "e-" + decimals).toFixed(
        decimals
      );
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
    valueOfId(val, table) {
      if (!val) return "";

      const thirdPartyPlayerByID =
        this.$store.getters["cacheOnDemand/thirdPartyPlayerByID"];

      let data = null;

      switch (table) {
        case "thirdPartyPlayers":
          data = thirdPartyPlayerByID(val);
          if (data) {
            return `${data.name} ${data.surname} (${data.email})`;
          }
          break;
      }
      return val;
    },
  },
};
</script>

<style lang="scss" scoped>
.tickets {
  & /deep/ .table th {
    font-size: 13px;
  }
  * /deep/ .table td {
    font-size: 13px;
  }
}

.local-pt {
  padding-top: 15px;

  .mb-3 {
    margin-bottom: 0 !important;
  }
}
</style>


